(ns practitest.frontend.milestone.readiness-index.subs
  (:require [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.milestone.readiness-index :as-alias ri]
            [practitest.frontend.milestones :as-alias milestones]
            [re-frame.core :as rf]
            [tick.core :as t]))

(def metrics
  #:metrics
  {:ccs  "Coverage Confidence"
   :ecs  "Execution Confidence"
   :rdrs "Remaining Defects Risk"})

(def metrics->tab
  #:metrics
  {:ccs  :requirements
   :ecs  :testsets
   :rdrs :issues})

(defn- score->status [score]
  (condp < score
    0.75 :status/ready
    0.50 :status/in-progress
    :status/at-risk))

(defn- url-for
  [milestone & [{:keys [tab]
                 :or   {tab :general}}]]
  (router/get-href ::milestones/edit milestone {} {:tab tab}))

(defn- prepare-metrics [{:keys [upcoming?] :as milestone}]
  (for [[metric label] metrics
        
        :let [score (milestone metric)
              tab   (metrics->tab metric)]]
    {:label  label
     :score  (when-not upcoming? score)
     :url    (url-for milestone {:tab tab})
     :status (score->status score)}))

(rf/reg-sub
 ::milestone
 (fn [[_ id] _]
   (rf/subscribe [::milestones/milestone id]))
 (fn [{:keys         [milestone_status milestone_start_date milestone_end_date]
       :metrics/keys [rrqi]
       :as           milestone} _]
   (let [upcoming?  (or (= milestone_status "Upcoming")
                        (nil? rrqi))
         start-date (js/Date. milestone_start_date)
         end-date   (js/Date. milestone_end_date)]
     (merge milestone
            {:start-date start-date
             :end-date   end-date
             :upcoming?  upcoming?
             ::ri/status (if upcoming?
                           :status/upcoming
                           (score->status rrqi))
             :url        (url-for milestone)
             :metrics    (vec (prepare-metrics milestone))}))))
